export default __webpack_public_path__ + "static/bariol_serif_bold_italic-webfont-fe6cca35621f53fd266c333c5d2506ea.eot";